



















































































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const getUrl = require('baimahu/url-with-param');
const API = {
  list: `${FCAPI}/shang/ruan/setting/butler`, // 管家列表
  add: `${FCAPI}/shang/ruan/setting/butler`, // 新增管家
  edit: `${FCAPI}/shang/ruan/setting/butler/`, // 编辑管家
};
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/each'),
};
function initModalValue(remote?: any) {
  remote = remote || {};
  return {
    weixin_nickname: remote.weixin_nickname || '',
    weixin_number: remote.weixin_number || '',
    mobile: remote.mobile || '',
    charge: remote.charge || '',
    status: remote.status || 1,
  };
}
function initData(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
// 初始化模态窗表单验证
function initValidatorMap() {
  return {
    weixin_nickname: {
      field: 'weixin_nickname',
      validate: (value: string): boolean => !!value,
      message: '请输入微信昵称',
    },
    weixin_number: {
      field: 'weixin_number',
      validate: (value: string): boolean => !!value,
      message: '请输入微信号',
    },
    mobile: {
      field: 'mobile',
      validate: (value: string): boolean => !!value,
      message: '请输入手机号',
    },
    charge: {
      field: 'charge',
      validate: (value: string): boolean => !!value,
      message: '请输入负责人',
    },
    status: {
      field: 'status',
      validate: (value: string): boolean => !!value,
      message: '请选择管家状态',
    },
  };
}
@Component
export default class HouseKeeper extends Vue {
  active_id: number = 0;
  is_loading: boolean = false;
  is_edit: boolean = false;
  is_show_add_modal: boolean = false;
  form_item_layout: any = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };
  validatorMap: any = initValidatorMap();
  modal_value: any = initModalValue();
  table_data: any = initData();
  paginationOption(data: any) {
    return {
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 0,
      total: data.total || 0,
      current: data.current || 0,
    };
  }

  validateCommit(form_value: any, validatorMap: any) {
    const form = form_value as any;
    let is_valid: boolean = true;
    _.each(validatorMap, (validator: any, field: string) => {
      if (!this.validate(field, validatorMap, form_value)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
      return false;
    }
    return is_valid;
  }
  validate(field: string, validatorMap: any, form_value: any) {
    const form = form_value as any;
    const is_valid = validatorMap[field]
      ? validatorMap[field].validate(form_value[field], form_value)
      : '';
    if (validatorMap[field]) {
      validatorMap[field].status = is_valid ? 'success' : 'error';
      validatorMap[field].help = is_valid ? '' : validatorMap[field].message;
      return is_valid;
    }
  }

  // 关闭模态窗
  closeModal() {
    this.is_show_add_modal = false;
    this.is_edit = false;
    this.modal_value = initModalValue();
    this.validatorMap = initValidatorMap();
  }

  // 验证手机号
  checkPhone() {
    const phone = this.modal_value.mobile;
    if (/^[1][3,4,5,7,8,9][0-9]{9}$/.test(phone)) {
      return true;
    }
    return false;
  }

  // 编辑管家
  editCharge(item: any) {
    this.active_id = item.id;
    this.is_show_add_modal = true;
    this.is_edit = true;
    this.modal_value = initModalValue(item);
  }

  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    await this.getList({
      page: 50,
      current: data.current,
    });
  }

  // 获取管家列表
  @changeLoading(['is_loading'])
  async getList(
    query_params: any = {
      page: 50,
    }
  ) {
    const url = getUrl(API.list, query_params);
    const res = await this.$axios.get(url);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.table_data = initData(res.data.data);
  }

  // 点击模态窗确定按钮
  @changeLoading(['is_loading'])
  async submit() {
    if (!this.validateCommit(this.modal_value, this.validatorMap)) {
      return;
    }
    if (!this.checkPhone()) {
      this.validatorMap.mobile.help = '手机号格式错误';
      this.validatorMap.mobile.status = 'error';
      return;
    } else {
      this.validatorMap.mobile.help = '';
      this.validatorMap.mobile.status = '';
    }
    const data = this.modal_value;
    let res;
    if (this.is_edit) {
      res = await this.$axios.put(`${API.edit}${this.active_id}`, {
        weixin_nickname: data.weixin_nickname,
        weixin_number: data.weixin_number,
        mobile: data.mobile,
        charge: data.charge,
        status: data.status,
      });
    } else {
      res = await this.$axios.post(API.add, {
        weixin_nickname: data.weixin_nickname,
        weixin_number: data.weixin_number,
        mobile: data.mobile,
        charge: data.charge,
        status: data.status,
      });
    }
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success(this.is_edit ? '编辑成功' : '新增成功');
    this.closeModal();
    await this.getList();
  }

  @changeLoading(['is_loading'])
  async created() {
    await this.getList(); // 获取管家列表
  }
}
